
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`createGlobalStyle`}</inlineCode>{` | v4 | web-only`}</h3>
    <p>{`A helper function to generate a special `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{` that handles global styles. Normally, styled components are automatically scoped to a local CSS class and therefore isolated from other components. In the case of `}<inlineCode parentName="p">{`createGlobalStyle`}</inlineCode>{`, this limitation is removed and things like CSS resets or base stylesheets can be applied.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">TaggedTemplateLiteral</Code>
    </Column>
    <Column mdxType="Column">A tagged template literal with your CSS and interpolations.</Column>
  </Row>
    </Table>
    <p>{`Returns a `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{` that does not accept children. Place it at the top of your React tree and the global styles will be injected when the component is "rendered".`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle\`
  body {
    color: \${props => (props.whiteColor ? 'white' : 'black')};
  }
\`

// later in your app

<React.Fragment>
  <GlobalStyle whiteColor />
  <Navigation /> {/* example of other top-level stuff */}
</React.Fragment>
`}</code></pre>
    <p>{`Since the `}<inlineCode parentName="p">{`GlobalStyle`}</inlineCode>{` component is a `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{`, that means it also has access to theming from the `}<a parentName="p" {...{
        "href": "/docs/api#themeprovider"
      }}><inlineCode parentName="a">{`<ThemeProvider>`}</inlineCode>{` component`}</a>{` if provided.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { createGlobalStyle, ThemeProvider } from 'styled-components'

const GlobalStyle = createGlobalStyle\`
  body {
    color: \${props => (props.whiteColor ? 'white' : 'black')};
    font-family: \${props => props.theme.fontFamily};
  }
\`

// later in your app

<ThemeProvider theme={{ fontFamily: 'Helvetica Neue' }}>
  <React.Fragment>
    <Navigation /> {/* example of other top-level stuff */}
    <GlobalStyle whiteColor />
  </React.Fragment>
</ThemeProvider>
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;